import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

import Navbar from "../../components/Navbar";
import Section from "../../components/Section";
import Loader from "../../components/Loader";

const LeaderBoard = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const { token } = useSelector((state) => state.auth);

  useEffect(() => {
    axios
      .get("/games")
      .then((res) => {
        setData(res.data.games);
      })
      .catch((err) => {
        console.log(err);
        toast.error("Uh Oh! Something went wrong while fetching data");
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  return (
    <Section id="leaderboard">
      {isLoading && <Loader />}
      <Navbar />

      <div className="date-selector">
        <div>
          <div className="btn">
            TODAY
            <div className="icons">
              <img src="/assets/imgs/date.png" alt="date" />
            </div>
          </div>
        </div>
        <div>
          <div className="btn">
            THIS WEEK
            <div className="icons">
              <img src="/assets/imgs/date.png" alt="date" />
              <img src="/assets/imgs/date.png" alt="date" />
            </div>
          </div>
        </div>
        <div>
          <div className="btn">
            THIS WEEK
            <div className="icons">
              <img src="/assets/imgs/date.png" alt="date" />
              <img src="/assets/imgs/date.png" alt="date" />
              <img src="/assets/imgs/date.png" alt="date" />
            </div>
          </div>
        </div>
      </div>

      <div className="min-page-container">
        {!token && (
          <div className="join">
            <img className="tada" src="/assets/imgs/tada.png" alt="tada" />
            <img className="check" src="/assets/imgs/check.png" alt="check" />
            <div className="d-none d-sm-block"></div>
            <div className="center">YOU CAN BE HERE</div>

            <div className="right">
              <div className="login">LOGIN HERE</div>
            </div>
          </div>
        )}

        {data.map((el, idx) => {
          const { _id, medal, player, hintsUsed, wrongGuesses, createdAt } = el;

          let medalImg = "medal-4";

          if (medal === "GOLD") {
            medalImg = "medal-1";
          } else if (medal === "SILVER") {
            medalImg = "medal-2";
          } else if (medal === "BRONZE") {
            medalImg = "medal-3";
          }

          return (
            <div
              className="game-listing-item c-pointer"
              onClick={() => navigate("/" + _id)}
              key={_id}
            >
              <div className="tag">{idx + 1}</div>
              <div className="game-listing-item__main">
                <div className="left">
                  <img src={`/assets/imgs/${medalImg}.png`} alt="medal" />

                  <img src="/assets/imgs/user-male.png" alt="gender" />
                </div>
                <div className="center">{player.name}</div>
                {/* <div className="right">{hintsUsed}</div> */}
                <div className="right">33 Gold Medals</div>
              </div>
            </div>
          );
        })}
      </div>

      {/* <div className="listing">
        <div className="table-container-wrap">
          <div className="table-container">
            <table>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Medal</th>
                  <th>Hints Used</th>
                  <th>Wrong Guesses</th>
                  <th>Date (GMT)</th>
                </tr>
              </thead>
              <tbody>
                {data.map((el, idx) => {
                  const {
                    _id,
                    player,
                    medal,
                    hintsUsed,
                    wrongGuesses,
                    createdAt,
                  } = el;

                  return (
                    <tr
                      className="c-pointer"
                      onClick={() => navigate("/" + _id)}
                      key={_id}
                    >
                      <td>{player.name}</td>
                      <td>{medal}</td>
                      <td>{hintsUsed}</td>
                      <td>{wrongGuesses}</td>
                      <td>{new Date(createdAt).toLocaleString()}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div> */}
    </Section>
  );
};

export default LeaderBoard;
